import { UserPreferences } from './cookieTypes';
import { Region } from '../../types/orderTypes';
import { getCookie, setCookie } from './cookie';

const UserPreferencesCookie = 'prefs';

function getPreferences(): UserPreferences {
  const sessionPreferences = sessionStorage.getItem(UserPreferencesCookie);
  const preferences = sessionPreferences || getCookie(UserPreferencesCookie);
  try {
    return (JSON.parse(preferences) || {}) as UserPreferences;
  } catch (e) {
    return {};
  }
}

function setPreferences(prefs: UserPreferences) {
  setCookie(UserPreferencesCookie, JSON.stringify(prefs), 365);
  sessionStorage.setItem(UserPreferencesCookie, JSON.stringify(prefs));
}

export function selectUserRegion(region: Region) {
  const currentPrefs = getPreferences();
  const preferences: UserPreferences = {
    ...currentPrefs,
    selectedRegion: region,
  };
  setPreferences(preferences);
}

export function getUserSelectedRegion(): Region | null {
  const currentPrefs = getPreferences();
  return currentPrefs.selectedRegion;
}
